<template>
    <div>
        <div class="form">
            <trial-over
                @close-modal="hide_trial_modal"
                v-if="trial_modal_shown"
                :shown="trial_modal_shown"
            ></trial-over>
            <div :class="{ 'events-group-header': true, 'list-visible': persons_kids && persons_kids.length > 0 }">
                <div class="events-group-header-icon"><span>K</span></div>
                Kids
            </div>
            <div
                class="kid-form form-wrapper"
                style="padding-top: 1.2rem;"
                v-if="persons_kids.length > 0"
                v-for="(new_kid, inx) in person.kids"
                :key="inx"
                v-show="!new_kid.removed"
            >
                <div class="kid-remove">
                    <span @click="remove_kid(inx, new_kid)" class="icon icon-reset"></span>
                </div>
                <div class="form-row">
                    <div class="form-hor">
                        <custom-input
                            @change="set_kid_value(inx, $event)"
                            input_type="text"
                            :invalid="new_kid.errors && new_kid.errors.includes('first_name')"
                            :value="new_kid.first_name"
                            :required="true"
                            limit="60"
                            @autosuggest="suggested(inx, $event)"
                            :autosuggest="true"
                            hint="Hint! Max 60 characters"
                            :name_capitalization="true"
                            error_msg="Error! This field is mandatory"
                            name="first_name"
                            label="First name"
                        ></custom-input>
                        <custom-input
                            @change="set_kid_value(inx, $event)"
                            input_type="text"
                            :value="new_kid.last_name"
                            limit="60"
                            hint="Hint! Max 60 characters"
                            :capitalize="true"
                            error_msg="Error! This field is mandatory"
                            name="last_name"
                            label="Last name"
                        ></custom-input>
                    </div>
                    <div class="form-hor">
                        <dropdown
                            @selected="set_kid_drop_value(inx, $event)"
                            :value="new_kid.gender"
                            name="gender"
                            :unsort="true"
                            label="Gender"
                            :options="person_gender_options"
                        ></dropdown>

                        <custom-input
                            @change="set_kid_value(inx, $event)"
                            datepicker="true"
                            icon_class="icon icon-calendar"
                            input_type="datepicker"
                            allow_input="true"
                            show_reset="true"
                            :value="new_kid.birthday"
                            format="dd.mm.yyyy"
                            name="birthday"
                            type="text"
                            label="Birthday, dd.mm.yyyy"
                        ></custom-input>
                    </div>
                </div>
            </div>
            <div :class="{ 'btn-container': true, 'list-visible': persons_kids && persons_kids.length > 0 }">
                <div v-if="person && person.status !== 'inactive'" @click="show_kid_form" class="btn-default">
                    + Add kid
                </div>
            </div>
        </div>
        <div class="form">
            <div class="events-group-header no-border">
                <div class="events-group-header-icon"><span>A</span></div>
                Additional info
            </div>
            <div class="form-hor">
                <div class="form-col">
                    <custom-textarea
                        :capitalize="true"
                        limit="250"
                        hint="Hint! Max 250 characters"
                        :punctuation_capitalization="true"
                        @change="set_value"
                        label="Special needs..."
                        :value="person.special_needs"
                        name="special_needs"
                    ></custom-textarea>
                </div>
            </div>
            <div class="form-hor">
                <div class="form-col">
                    <custom-textarea
                        :capitalize="true"
                        limit="250"
                        hint="Hint! Max 250 characters"
                        :punctuation_capitalization="true"
                        @change="set_value"
                        label="Additional info..."
                        :value="person.additional_info"
                        name="additional_info"
                    ></custom-textarea>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import router from "@/router";
import dropdown from "@/components/pages/dropdown.vue";
import customInput from "@/components/pages/custom-input.vue";
import customTextarea from "@/components/pages/custom-textarea.vue";
import { mapActions, mapGetters, mapMutations, mapState } from "vuex";
import TrialOver from "./../trial-over-modal.vue";

export default {
    name: "kids_and_additional_info",
    props: [],
    components: { dropdown, customInput, customTextarea, TrialOver },
    data() {
        return {
            trial_modal_shown: false
        };
    },
    mounted() {
        this.get_logged_in_user();
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.get_logged_in_user();
            next();
        });
    },
    computed: {
        ...mapState(["user"]),
        ...mapState("StorePeople", [
            "person",
            "kid",
            "person_group_options",
            "person_gender_options",
            "person_save_btn_loading",
            "errors",
            "kid_errors"
        ]),
        ...mapGetters("StorePeople", ["persons_kids"])
    },
    methods: {
        ...mapActions(["get_logged_in_user"]),
        ...mapMutations("StorePeople", [
            "set_save_btn_state",
            "clear_person",
            "set_btn_mode",
            "update_field",
            "add_kid",
            "set_person_kid",
            "validate_kid_fields",
            "remove_persons_kid"
        ]),
        set_drop_value(payload) {
            this.check_validation_show_btn();
            this.update_field({
                prop_name: payload.name,
                prop_value: payload.value
            });
        },
        set_kid_drop_value(kid_index, args) {
            if (this.person.kids[kid_index][args.prop_name] !== args.prop_value) {
                this.check_validation_show_btn();
            }
            this.set_person_kid({
                prop_name: args.name,
                prop_value: args.value,
                index: kid_index
            });
        },
        hide_trial_modal() {
            this.trial_modal_shown = false;
        },
        set_value(args) {
            this.check_validation_show_btn();
            this.update_field(args);
        },
        set_kid_value(kid_index, args) {
            if (this.person.kids[kid_index][args.prop_name] !== args.prop_value) {
                this.check_validation_show_btn();
            }
            args["index"] = kid_index;
            this.set_person_kid(args);
            // if (this.validate_kid(kid_index)) {
            //     this.set_btn_mode(true);
            // } else {
            //     this.set_btn_mode(false);
            //}
        },
        remove_kid(inx, kid) {
            this.check_validation_show_btn();
            this.remove_persons_kid(kid);
        },
        check_validation_show_btn() {
            if (this.validate_person()) {
                this.set_btn_mode(true);
            } else {
                this.set_btn_mode(false);
            }
            this.set_save_btn_state(true);
        },
        show_kid_form() {
            if (this.user && this.user.active_plan && this.user.active_plan.id) {
                this.check_validation_show_btn();
                let new_kid = {
                    ...this.kid
                };
                this.add_kid(new_kid);
            } else {
                this.trial_modal_shown = true;
            }
        },
        suggested(pl, evt, index) {
            let fields = ["first_name", "last_name", "gender", "birthday", "temp_id"];
            fields.forEach(f => {
                if (evt[f]) {
                    this.set_person_kid({
                        prop_name: f,
                        prop_value: evt[f],
                        index: pl
                    });
                }
            });
        },
        validate_kid(index) {
            let kid_name = this.person.kids[index]["first_name"];
            let kid_last_name = this.person.kids[index]["last_name"];
            if (kid_name && kid_name.trim() && kid_last_name && kid_last_name.trim()) {
                return true;
            } else {
                return false;
            }
        },
        validate_person() {
            if (this.person.age_group === "adult") {
                if (
                    this.person.first_name &&
                    this.person.first_name.trim() &&
                    this.person.last_name &&
                    this.person.last_name.trim()
                ) {
                    return true;
                } else {
                    return false;
                }
            } else {
                if (this.person.first_name && this.person.first_name.trim()) {
                    return true;
                } else {
                    return false;
                }
            }
        }
    }
};
</script>

<style scoped>
.kid-form {
    position: relative;
}

.events-group-header.no-border {
    border-bottom: 0;
}

.events-group-header.list-visible {
    border-bottom: 0;
    padding-bottom: 0;
}

.kid-remove .icon-reset {
    top: -1.6rem;
    bottom: initial;
}

.btn-default {
    align-self: flex-end;
    margin-left: auto;
    padding: 0.4rem 1.2rem;
}

.btn-container {
    display: flex;
    margin-top: 1.2rem;
}

.btn-container.list-visible {
    margin-top: -2rem;
}

.events-group-header.no-border {
    border-bottom: 0;
}

.form-row {
    display: flex;
    padding-bottom: 0;
    padding-top: 0;
}

@media only screen and (max-width: 46rem) {
    .form-row {
        flex-direction: column;
    }
}

.events-group-header.list-visible {
    border-bottom: 0;
    padding-bottom: 0;
}

.form-hor {
    display: flex;
    flex-direction: column;
}

.form-row .form-hor {
    flex: 1;
    margin-left: 1rem;
    margin-right: 1rem;
}

.form-wrapper {
    display: flex;
    margin-left: -1rem;
    margin-right: -1rem;
}

@media only screen and (max-width: 38rem) {
    .form-wrapper {
        flex-direction: column;
    }
}

.form-group {
    margin-right: 0 !important;
}

.form-container {
    margin-bottom: 4rem;
}

.people-item-icon-container {
    width: 13.6rem;
    height: 13.6rem;
    margin: 0;
}

.people-item-icon-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 2rem;
}

.people-item-icon-container span {
    width: 8rem;
    height: 8rem;
}

.btn-container.list-visible {
    margin-top: 0;
}
</style>
